import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";

import QuotesContainer from "~/Containers/QuotesContainer";

class PreviousPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refresh: false,
    };
  }
  checkRecent = () => {
    console.log("error checkRecent");
    this.setState({ refresh: true });
  };

  render() {
    const { refresh } = this.state;

    if (refresh) {
      this.setState({ refresh: false });
      return <Redirect to={`/`} />;
    }

    return (
      <div className="home-page-component">
        <Helmet>
          <title>Quote of the Day | Dream Chimney</title>
        </Helmet>

        <QuotesContainer render={(items) => items} />
      </div>
    );
  }
}

export default PreviousPage;
